import { gtag } from '../gtag';
import { GoogleTagManagerConsentSettings } from '../GoogleTagManager.types';

export const updateConsent = (
  consentSettings: GoogleTagManagerConsentSettings
): void => {
  const maxRetries = 50;
  const delay = 200; // milliseconds
  let retries = 0;

  const applyConsentSettings = () => {
    // Check if `dataLayer` has the required 'default' consent entry
    const hasDefaultConsent = window.dataLayer?.some(
      (item) => item[0] === 'consent' && item[1] === 'default'
    );

    if (!hasDefaultConsent) {
      // Retry until 'default' consent is found
      if (retries < maxRetries) {
        retries++;
        setTimeout(applyConsentSettings, delay);
      } else {
        console.warn(
          `Failed to apply consent settings (default consent missing) after ${maxRetries} retries`,
          consentSettings
        );
      }
      return;
    }

    // Find the most recent 'consent' update in the `dataLayer`
    const latestConsentUpdate = (() => {
      for (let i = window.dataLayer.length - 1; i >= 0; i--) {
        const item = window.dataLayer[i];
        if (item[0] === 'consent' && item[1] === 'update') {
          return item[2] as GoogleTagManagerConsentSettings;
        }
      }
      return null;
    })();

    // Check if the incoming consent settings differ from the latest update
    const shouldUpdate =
      !latestConsentUpdate ||
      JSON.stringify(latestConsentUpdate) !== JSON.stringify(consentSettings);

    if (shouldUpdate) {
      // Use `gtag` to update consent, as it aligns with GTM's requirements
      gtag('consent', 'update', consentSettings);
      // window.dataLayer.push({
      //   event: 'update_consent',
      //   update_consent: consentSettings,
      // });
    }
  };

  applyConsentSettings();
};
